import React, { Component } from "react";
import ValidatedRegisterForm from "../components/ValidatedRegisterForm";
import SideBar from "../components/Menu/SideBar";
import NavBar from "../components/Menu/NavBar";

class WrappedUp extends Component {
  constructor(props) {
    super(props);

    this.state = {};
  }

  render() {
    return (
      <div>
        <div className="app-sidenav">
          <div className="login-main-text">
            <SideBar />
          </div>
        </div>
        <div className="app-wrapper expanded">
          <NavBar />
          <div className="app-container">{this.props.children}</div>
        </div>
      </div>
    );
  }
}

export default WrappedUp;
